/* oxlint-disable react/react-compiler -- Existing code is not yet compatible with React Compiler checks. */
import * as React from 'react';

import type { AnimationCallbacks, AnimationPhases } from './animation';
import { AnimateInternalManagerContext } from './context';

/**
 * Bind a view to a lifecycle animation of the upper AnimateLifeCycle.
 */
export function useAnimateLifecycle<T extends HTMLElement = HTMLElement>(
    phases: AnimationPhases,
    callbacks: AnimationCallbacks = {}
): React.Ref<T> {
    const ref = React.useRef<T>(null);
    const { bindAnimations } = React.useContext(AnimateInternalManagerContext);

    const animatedRef = bindAnimations(ref as React.Ref<HTMLElement>, phases, callbacks);

    return animatedRef as React.Ref<T>;
}
